import { render } from "./ProductProperty.vue?vue&type=template&id=5e260f83&scoped=true"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"

import "./ProductProperty.vue?vue&type=style&index=0&id=5e260f83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e260f83"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QBtn,QMenu,QList,QItem,QItemSection,QItemLabel});
